
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ArterialBloodGas',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/ArterialBloodGas.vue